import { t } from "i18next"
import {
    Command,
    CommandDialog,
    CommandEmpty,
    CommandGroup,
    CommandInput,
    CommandItem,
    CommandList,
    CommandSeparator,
    CommandShortcut,
} from "../../ui/Command"
import { useAppStore } from "../../stores/RootStore"
import { useNavigate } from "react-router-dom"
import { isUndefined } from "lodash"
import { Button } from "../../ui/Button"
import { useTabsStore } from "../../stores/TabsStore"



export function FlowCommand({onClose}:{onClose?: () => void}) {
  const navigate = useNavigate()
  const {equipments, persons, screens, devices, reports} = useAppStore()
  const {} = useTabsStore()

  function goToPage(path: string) {
    navigate(path)
    if(isUndefined(onClose)) {
      return
    } else {
      onClose!()
    }
  }

  function goToReport(tabId: string) {
    navigate("/analytics")
    if(isUndefined(onClose)) {
      return
    } else {
      onClose!()
    }
  }

  return (
    <Command >
      <CommandInput placeholder={t('search_by_flow')} />
      <CommandList className="max-h-[480px]">
        <CommandEmpty>{t('no_data')}</CommandEmpty>
        <CommandGroup 
          heading={
            <div className="flex justify-between items-center ">
              <span className="text-sm">{t('monitoring')}</span>
              <div>
                <Button size={"xs"} variant={"link"} onClick={() => goToPage(`/monitoring`)}>{t('all')}</Button>
                <Button size={"xs"} variant={"link"} onClick={() => goToPage(`/monitoring/new`)}>{t('add')}</Button>
              </div>
            </div>
          } 
          value={`${t('monitoring')} ${t('add')} ${t('add_monitoring')}`}
        >
          {screens?.map(s => (
            <CommandItem 
              key={s.id}
              value={`${s.attributes.name}`}
              onSelect={() => goToPage(`/monitoring/${s.id}`)}
            >
              <div className="flex flex-col">
                <span>{s.attributes.name}</span>
                <span className="text-xs">{s.attributes.division ? s.attributes.division.name : <></>}</span>
              </div>
            </CommandItem>
          ))}
        </CommandGroup>
        <CommandSeparator />
        <CommandItem 
            value={`${t('repair')} ${t('service')} ${t('maintenance')}`}
            onSelect={() => goToPage(`/managment/maintenance`)}
          >
          <div className="flex flex-col px-1">
            <span>{t('repair_and_service')}</span>
          </div>
        </CommandItem>
        <CommandSeparator />
        <CommandGroup 
          heading={
            <div className="flex justify-between items-center ">
              <span className="text-sm">{t('reports')}</span>
              <div>
                <Button size={"xs"} variant={"link"} onClick={() => goToPage(`/analytics`)}>{t('all')}</Button>
                <Button size={"xs"} variant={"link"} onClick={() => goToPage(`/analytics`)}>{t('add')}</Button>
              </div>
            </div>
          } 
          value={t('reports')}
        >
          {reports?.map(report => (
            <CommandItem 
              key={report.name}
              value={`${report.title} ${t('report')} ${t('reports')} ${t('analytic')}`}
              onSelect={() => goToReport(report.name)}
            >
              <div className="flex flex-col">
                {report.title}
              </div>
            </CommandItem>
          ))}
        </CommandGroup>
        <CommandSeparator />
        <CommandGroup 
          heading={
            <div className="flex justify-between items-center ">
              <span className="text-sm">{t('equipment')}</span>
              <div>
                <Button size={"xs"} variant={"link"} onClick={() => goToPage(`/data/equipment`)}>{t('all')}</Button>
                <Button size={"xs"} variant={"link"} onClick={() => goToPage(`/data/equipment/new`)}>{t('add')}</Button>
              </div>
            </div>
          } 
          value={t('equipment')}
        >
          {equipments?.map(e => (
            <CommandItem 
              key={e.id}
              value={`${t('equipment')} ${e.attributes.inventory_number}, ${e.attributes.name}, ${e.attributes.equipment_model_name}, ${e.attributes.equipment_type_name}, ${e.attributes.factory_number}`}
              onSelect={() => goToPage(`/data/equipment/${e.id}`)}
            >
              <div className="flex flex-col">
                <span>{e.attributes.inventory_number}, {e.attributes.name}</span>
                <span className="text-xs">{e.attributes.equipment_type_name}, {e.attributes.producer_name}, {e.attributes.equipment_model_name}</span>
              </div>
            </CommandItem>
          ))}
        </CommandGroup>
        <CommandSeparator />
        <CommandGroup 
          heading={
            <div className="flex justify-between items-center ">
              <span className="text-sm">{t('staff')}</span>
              <div>
                <Button size={"xs"} variant={"link"} onClick={() => goToPage(`/data/staff`)}>{t('all')}</Button>
                <Button size={"xs"} variant={"link"} onClick={() => goToPage(`/data/staff/new`)}>{t('add')}</Button>
              </div>
            </div>
          } 
          value={t('staff')}
        >
          {persons?.map(p => (
            <CommandItem 
              key={p.id}
              value={`${t('staff')} ${p.attributes.last_name}, ${p.attributes.first_name}, ${p.attributes.middle_name}, ${p.attributes.post_name}`}
              onSelect={() => goToPage(`/data/staff/${p.id}`)}
            >
              <div className="flex flex-col">
                <span>{p.attributes.last_name} {p.attributes.first_name} {p.attributes.middle_name}</span>
                <span className="text-xs">{p.attributes.post_name}</span>
              </div>
            </CommandItem>
          ))}
        </CommandGroup>
        <CommandSeparator />
        <CommandGroup 
          heading={
            <div className="flex justify-between items-center ">
              <span className="text-sm">{t('devices')}</span>
              <div>
                <Button size={"xs"} variant={"link"} onClick={() => goToPage(`/data/devices`)}>{t('all')}</Button>
                <Button size={"xs"} variant={"link"} onClick={() => goToPage(`/data/devices/new`)}>{t('add')}</Button>
              </div>
            </div>
          } 
          value={t('devices')}
        >
          {devices?.map(d => (
            <CommandItem 
              key={d.id}
              value={`${t('device')} ${d.attributes.serial_number}`}
              onSelect={() => goToPage(`/data/devices/${d.id}`)}
            >
              <div className="flex flex-col">
                <span>{d.attributes.serial_number}</span>
                <span className="text-xs">{d.attributes.online ? t('online') : t('offline')}</span>
              </div>
            </CommandItem>
          ))}
        </CommandGroup>
        <CommandSeparator />
        <CommandGroup 
          heading={
            <div className="flex justify-between items-center ">
              <span className="text-sm">{t('directories')}</span>
              <div>
                <Button size={"xs"} variant={"link"} onClick={() => goToPage(`/data/directories`)}>{t('all')}</Button>
              </div>
            </div>
          } 
          value={t('directories')}
        >
          <CommandItem 
            key={"shifts"}
            value={`${t('shifts')}`}
            onSelect={() => goToPage(`/data/shifts`)}
          >
            <div className="flex w-full justify-between items-center">
              <span>{t('shifts')}</span>
            </div>
          </CommandItem>
          <CommandItem 
            key={"divisions"}
            value={`${t('divisions')}`}
            onSelect={() => goToPage(`/data/divisions`)}
          >
            <div className="flex flex-col">
              <span>{t('divisions')}</span>
            </div>
          </CommandItem>
          <CommandItem 
            key={"equipment_types"}
            value={`${t('equipment_types')}`}
            onSelect={() => goToPage(`/data/equipment_types`)}
          >
            <div className="flex flex-col">
              <span>{t('equipment_types')}</span>
            </div>
          </CommandItem>
          <CommandItem 
            key={"manufactures"}
            value={`${t('manufactures')}`}
            onSelect={() => goToPage(`/data/manufactures`)}
          >
            <div className="flex flex-col">
              <span>{t('manufactures')}</span>
            </div>
          </CommandItem>
          <CommandItem 
            key={"positions"}
            value={`${t('positions')}`}
            onSelect={() => goToPage(`/data/positions`)}
          >
            <div className="flex flex-col">
              <span>{t('positions')}</span>
            </div>
          </CommandItem>
        </CommandGroup>
      </CommandList>
    </Command>
  )
}
